import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { Mutations } from '@/api/mutations.enum'
import { submitFeedback } from '@/api/actions/feedback/feedbackActions'
import type {
    ISubmitFeedbackParams,
    IFeedbackApiResponse,
    IFeedbackApiError,
    IRateLimitError,
    IValidationError,
    IAuthenticationError,
} from '@/api/actions/feedback/feedbackActions.types'

export interface FeedbackFormData {
    request_type: 'bug' | 'feature' | 'improvement' | 'general' // Reordered to match backend
    description: string // Changed from feedback_text to match backend
    wants_follow_up: boolean
}

export const useSubmitFeedback = () => {
    const mutation = useMutation<
        IFeedbackApiResponse,
        AxiosError<IFeedbackApiError | IRateLimitError | IValidationError | IAuthenticationError>,
        FeedbackFormData
    >({
        mutationKey: [Mutations.submitFeedback],
        mutationFn: async (formData: FeedbackFormData) => {
            // Get current dashboard location from window
            const dashboard_location = window.location.pathname

            const params: ISubmitFeedbackParams = {
                request_type: formData.request_type,
                description: formData.description,
                wants_follow_up: formData.wants_follow_up,
                dashboard_location,
                // Note: browser_user_agent, user_type, email are auto-populated by backend
            }
            return submitFeedback(params)
        },
    })

    return mutation
}
